import { StorageAccess } from "./storageAccess";

class StorageX extends StorageAccess{}

export default new StorageX();